import { Navigate } from "react-router-dom";
import { DEFAULT_TAB_PARAM } from "./TabsPage";

// Lists rendered as tabs by a TabsPage keep their own resource routes registered so every
// react-admin "back to list" redirect keeps working — they bounce to the matching tab.
const RedirectToTab = ({ to, tabKey, param = DEFAULT_TAB_PARAM }) => (
  <Navigate
    to={`/${to}?${param}=${tabKey}`}
    replace
  />
);

export default RedirectToTab;
